import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { ApiError } from '../../../../../../models/ApiError';
import { FormInputText } from '../../../../../inputs/FormInputText';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { ButtonClassNames, InputTextFormat, InputRegexPattern } from '../../../../../../models/Common';
import { formatPhone } from '../../../../../../utils';
import { userInfoApi } from '../../../../../../services/apiServices/user/userInfo';
import { useCustomSnackbar } from '../../../../../../hooks/useCustomEnqueueSnackbar';

interface AddNewBackupPhoneProps {
  handleClose: () => void;
}

export const AddNewBackupPhone: FC<AddNewBackupPhoneProps> = ({ handleClose }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const methods = useForm<{ phoneNumber: string }>();
  const { handleSubmit, setError } = methods;
  const [addBackupPhoneApi, { isLoading }] = userInfoApi.useAddBackupPhoneMutation();

  const handleAddNewPhone = async ({ phoneNumber }: { phoneNumber: string }) => {
    try {
      await addBackupPhoneApi({ phone: formatPhone(phoneNumber) })
        .unwrap()
        .then(() => {
          customEnqueueSnackbar(t('snackbar.backupPhoneNumberAddedSuccessfully'), 'success');
          handleClose();
        });
    } catch (err) {
      const error = err as ApiError;
      setError('phoneNumber', {
        type: 'server',
        message: error?.data?.error.message,
      });
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('accountSettings.addingBackupPhoneNumber')}</article>
      </div>
      <form className="modals__form" onSubmit={handleSubmit(handleAddNewPhone)}>
        <FormProvider {...methods}>
          <FormInputText
            name="phoneNumber"
            className="primary"
            label={t('input.phone')}
            isRequired
            format={InputTextFormat.Phone}
            type="tel"
            pattern={InputRegexPattern.Phone}
          />
          <div className="modals__btn-group">
            <CustomMUIButton
              label={t('buttons.save')}
              type="submit"
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
              isLoading={isLoading}
            />
          </div>
        </FormProvider>
      </form>
    </div>
  );
};
